<script>
    import BaseDialog from './BaseDialog.svelte';

    let {
        dialogRef = $bindable(),
        menuItems = [],
        onKeydown = null
    } = $props();

    function focus(x) { alert('f');x.focus(); }
</script>

<BaseDialog bind:dialogRef={dialogRef} size="sm:max-w-3xl" title="Keyboard Shortcuts Help" {onKeydown} showClose={false}>
    {#snippet children({ dialog })}
        <!-- svelte-ignore a11y_no_noninteractive_tabindex -->
        <!-- svelte-ignore a11y_no_static_element_interactions -->
        <div tabindex="0" onkeydown={onKeydown} class="p-6">
            <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                <div class="flex items-start">
                    <svg class="w-5 h-5 text-blue-600 mr-3 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
                    </svg>
                    <div class="text-sm text-blue-900">
                        <p class="font-medium mb-1">How to use numbered shortcuts</p>
                        <p class="text-blue-800">
                            When numbered lists appear, press the corresponding number to make that choice.
                            Pressing an invalid key will return to the waveform and show "unknown choice" in the upper right corner.
                        </p>
                    </div>
                </div>
            </div>

            {#if menuItems.length > 0}
                <div class="space-y-3">
                    <h4 class="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-4">Available Options</h4>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {#each menuItems as item, i}
                            <div class="flex items-center p-3 bg-gradient-to-r from-gray-50 to-white rounded-lg border border-gray-200 hover:border-indigo-300 transition-colors">
                                <div class="flex-shrink-0 w-8 h-8 bg-indigo-600 text-white rounded-lg flex items-center justify-center font-bold text-sm mr-3 shadow-sm">
                                    {i+1}
                                </div>
                                <span class="text-gray-800 font-medium">{item}</span>
                            </div>
                        {/each}
                    </div>
                </div>
            {/if}

            <div class="mt-6 pt-4 border-t border-gray-200">
                <p class="text-xs text-gray-500 text-center">
                    Press <kbd class="px-2 py-1 bg-gray-200 rounded text-gray-700 font-mono text-xs">ESC</kbd> or click outside to close this dialog
                </p>
            </div>
        </div>
    {/snippet}
</BaseDialog>
